import { Button, Grow, Icon } from "@mui/material";
import MyToastShow from "@/components/Layout/MyToast";
import { memo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { addInforme } from "@/redux/features/cartSlice";
import { IInforme } from "@/redux/models";
import { useAppDispatch } from "@/redux/store";
import { useAddItemToCartMutation } from "@/redux/api/cartApi";

interface RepedirButtonProps {
    selectedInformes: IInforme[];
    isVisible: boolean;
}

const RepedirButton = ({ selectedInformes, isVisible }: RepedirButtonProps) => {
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const [addItemToCart] = useAddItemToCartMutation();
    const [isLoading, setIsLoading] = useState(false);

    const handleRepedirInformes = async () => {
        setIsLoading(true);
        
        try {
            // Process each informe and add to cart via API
            for (const informe of selectedInformes) {
                const { archivosAdjuntos, ...informes } = informe;
                const {
                    id,
                    informeEntregadoGobierno,
                    pdfLiquidacion,
                    liquidado,
                    entrada,
                    estadoGeneral,
                    fechaDeCreacion,
                    fechaEntregadoGobierno,
                    idCarrito,
                    keyPrecio,
                    expiracionDeRecuperacion,
                    ...informeFinal
                } = { ...informes, _id: "", repedido: false, archivosAdjuntos: [], printed: false } as IInforme

                // Add to cart via API
                try {
                    await addItemToCart(informeFinal as any).unwrap();
                } catch (apiError) {
                    console.error('Error adding item to cart via API:', apiError);
                    // Fallback to local store if API fails
                    dispatch(addInforme(informeFinal as IInforme));
                }
            }
            
            navigate("/carrito");
            MyToastShow({ 
                message: 'Informe/s agregado a la carpeta, recuerde que al volver a pedir un informe, los archivos enviados en el original, no serán adjuntados.', 
                type: 'success' 
            });
        } catch (error) {
            console.error('Error processing informes:', error);
            MyToastShow({ 
                message: 'Error al agregar los informes al carrito', 
                type: 'error' 
            });
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <Grow in={isVisible}>
            <Button
                variant="outlined"
                startIcon={<Icon>payments</Icon>}
                onClick={handleRepedirInformes}
                disabled={isLoading}
            >
                {isLoading ? "Agregando..." : "Re pedir"}
            </Button>
        </Grow>
    );
};

export default memo(RepedirButton, (prev, next) => 
    prev.selectedInformes.length === next.selectedInformes.length && 
    prev.isVisible === next.isVisible
);
